import { TenderConfigOptions, TenderMethod } from '@rygen/rygen-ui/model';

import { RateSelectionReason } from '../rate/RateSelectionReason';

export class TenderToCarrierRequest {
  method: TenderMethod;
  tenderConfigOptions?: TenderConfigOptions;
  rateSelectionReason?: RateSelectionReason;

  constructor(
    method: TenderMethod,
    tenderConfigOptions?: TenderConfigOptions,
    rateSelectionReason?: RateSelectionReason,
  ) {
    this.method = method;
    if (tenderConfigOptions) {
      this.tenderConfigOptions = new TenderConfigOptions(tenderConfigOptions);
    }
    if (rateSelectionReason) {
      this.rateSelectionReason = new RateSelectionReason(rateSelectionReason);
    }
  }
}
